// extracted by mini-css-extract-plugin
export default {"header":"List_header__x2UpC","cardContainer":"List_cardContainer__26fIV","selected":"List_selected__ajA7y","icon":"List_icon__x1k3g"};